import D2C_ServiceData from './Data'

class D2C_ServiceRedis extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 21
  static typeName = 'redis'
  static typeTitle = 'Redis'
  static color = '#cc1100'
  static methods = {
    ...D2C_ServiceData.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'redis.conf', text: require('raw-loader!@/assets/configs/redis-redis.conf').default, custom: false},
      ],
      variables: [...D2C_ServiceData.fields.configs.variables, '$redisAuth'],
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'redis',
    },
    password: {
      default: '',
      label: 'Password',
      path: 'password',
      required: false,
      width: 9,
      validate(value, entity) {
        if (entity.remoteAccess && !value) {
          return 'Database with remote access must have a password!'
        }
        if (value && value.length < 6) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 6379},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '6.2',
      enum: ['3.2', '4.0', '5.0', '6.0', '6.2'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/data', sync: false},
      ],
    },
  }
}

export default D2C_ServiceRedis
